(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestsellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function loadSwiperScript(callback) {
      if (window.Swiper) {
        callback();
        return;
      }
      var script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.0.5/swiper-bundle.min.js';
      script.onload = callback;
      document.head.appendChild(script);
    }

    loadSwiperScript(function () {
      document.querySelectorAll('.bestsellers__grid').forEach(function (el) {
        var swiperInstance = null;
        var mq = window.matchMedia('(max-width: 1023px)');

        function enableSwiper() {
          if (!swiperInstance) {
            swiperInstance = new window.Swiper(el, {
              wrapperClass: 'bestsellers__wrapper',
              slideClass: 'bestsellers__card',
              slidesPerView: 1.5,
              breakpoints: {
                480: {
                  slidesPerView: 2.5,
                },
              },
              spaceBetween: 16,
              pagination: {
                el: el.querySelector('.bestsellers__pagination'),
                clickable: true,
              },
            });
          }
        }

        function disableSwiper() {
          if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
          }
        }

        function handleChange(e) {
          if (e.matches) {
            enableSwiper();
          } else {
            disableSwiper();
          }
        }

        handleChange(mq);
        mq.addEventListener('change', handleChange);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-photos-carousel"]) return;
  try {
    
  (function () {
    function loadSwiperScript(callback) {
      if (window.Swiper) {
        callback();
        return;
      }
      var script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.0.5/swiper-bundle.min.js';
      script.onload = callback;
      document.head.appendChild(script);
    }

    loadSwiperScript(function () {
      document.querySelectorAll('.cust-photos__swiper').forEach(function (el) {
        var swiperInstance = null;
        var mq = window.matchMedia('(max-width: 767px)');

        function enableSwiper() {
          if (!swiperInstance) {
            swiperInstance = new window.Swiper(el, {
              wrapperClass: 'cust-photos__wrapper',
              slideClass: 'cust-photos__slide',
              slidesPerView: 2.3,
              spaceBetween: 10,
            });
          }
        }

        function disableSwiper() {
          if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
          }
        }

        function handleChange(e) {
          if (e.matches) {
            enableSwiper();
          } else {
            disableSwiper();
          }
        }

        handleChange(mq);
        mq.addEventListener('change', handleChange);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function loadSwiperScript(callback) {
      if (window.Swiper) {
        callback();
        return;
      }
      var script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.0.5/swiper-bundle.min.js';
      script.onload = callback;
      document.head.appendChild(script);
    }

    loadSwiperScript(function () {
      document.querySelectorAll('.home-reviews__swiper').forEach(function (el) {
        new window.Swiper(el, {
          slidesPerView: 1.2,
          spaceBetween: 24,
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            768: { slidesPerView: 2.2, spaceBetween: 24 },
            1024: { slidesPerView: 3, spaceBetween: 30 },
          },
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
